import {Card, DatePicker, DatePickerProps, Select} from "antd";
import {useAppDispatch} from "../../../../redux/store";
import styles from './blockOneSettings.module.sass'
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/ru_RU";
import dateIcon from "../../../../assets/datePickerIcon.svg";
import closeIcon from "../../../../assets/close.svg";
import React from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import updateLocale from "dayjs/plugin/updateLocale";
import {citiesSF, levels, marketsSF} from "../../../../common/optionsForSkuFood";
import {RangePickerProps} from "antd/es/date-picker";
import {changeCityCFAC, changeDateCFAC, changeLevelCFAC, changeSpmCFAC} from "../../../../redux/categoryFoodReducer";

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(updateLocale);
dayjs.updateLocale('zh-cn', {
    weekStart: 1,
});

// Тип пропсов для компонента: параметры фильтрации для блока 1
type BlockOneSettingsPropsType = {
    date: string[]
    city: string
    store_name: string
    level_category: string
}

export const BlockOneSettings = ({date, city, store_name, level_category}: BlockOneSettingsPropsType) => {

    // Инициализация dispatch для отправки экшенов в Redux
    const dispatch = useAppDispatch()

    // Формат недели для отображения в DatePicker
    const weekFormat = 'YYYY-MM-DD';

    // Кастомный формат для отображения диапазона дат недели
    const customWeekStartEndFormat: DatePickerProps['format'] = (value) =>
        `${dayjs(value).startOf('week').format(weekFormat)} / ${dayjs(value)
            .endOf('week')
            .format(weekFormat)}`;

    // Обработчик изменения даты: обновляет дату в Redux store
    const onChange = (
        value: DatePickerProps['value'] | RangePickerProps['value'],
        dateString: string,
    ) => {
        dispatch(changeDateCFAC(dateString.split(' / ')));
    };

    // Формирование опций для селекторов городов, маркетов и уровней
    const cityOptions = citiesSF.map((el) => ({label: el, value: el}))
    const marketsOptions = marketsSF.map((el) => ({label: el, value: el}))
    const levelsOptions = Object.values(levels).map((el) => ({label: el, value: el}))

    // Отрисовка карточки с фильтрами: неделя, город, маркет, уровень
    return (
        <Card className={styles.card}>
            <div className={styles.content}>
                {/* Выбор недели */}
                <DatePicker
                    defaultValue={dayjs(date[0]).day(1)}
                    locale={locale}
                    style={{width: '320px'}}
                    picker={'week'}
                    suffixIcon={<img src={dateIcon} alt={'select'}/>}
                    allowClear={{
                        clearIcon: <img className={styles.closeIcon} src={closeIcon} alt={'clear'}/>
                    }}
                    format={customWeekStartEndFormat}
                    onChange={onChange}

                />
                {/* Выбор города */}
                <Select placeholder={'Город'} options={cityOptions} value={city} className={styles.select}
                        onChange={(value: string) => dispatch(changeCityCFAC(value))}/>
                {/* Выбор маркета */}
                <Select placeholder={'Маркет'} options={marketsOptions} value={store_name} className={styles.select}
                        onChange={(value: string) => dispatch(changeSpmCFAC(value))}/>
                {/* Выбор уровня категории */}
                <Select placeholder={'Уровень'} options={levelsOptions} value={level_category} className={styles.select}
                        onChange={(value: string) => dispatch(changeLevelCFAC(value))}/>
            </div>
        </Card>
    );
};
